import { create } from 'zustand';
import type { Harbor } from 'contracts/harbors';

type State = {
  selectedHarbor: Harbor | null;
}

type Actions = {
  setSelectedHarbor: (harbor: Harbor | null) => void;
  clearSelectedHarbor: () => void;
}

export const useSelectedHarborState = create<State & Actions>((set) => ({
  selectedHarbor: null,
  setSelectedHarbor: (harbor) => set({ selectedHarbor: harbor }),
  clearSelectedHarbor: () => set({ selectedHarbor: null }),
}));
